// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item[data-v-9d554f92]{margin-bottom:3px}", ""]);
// Exports
module.exports = exports;
